<app-generic-page-type01 [policyData]="policyData"></app-generic-page-type01>
